import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "./Button";
import { Modal } from "./Modal";

// Stacking slots from the theme scale. The class strings stay whole so
// Tailwind can see them.
const LAYER_CLASS = {
  dialog: "z-dialog",
  confirm: "z-confirm",
  overlay: "z-overlay",
} as const;

// Centred dialog chrome: a dimmed backdrop that dismisses, and a panel that
// keeps the click. `layer` picks the token; dialogs sit on `dialog`.
export function Popup({
  onClose,
  children,
  className,
  layer = "dialog",
}: {
  onClose: () => void;
  children: ReactNode;
  className?: string;
  layer?: keyof typeof LAYER_CLASS;
}) {
  return (
    <Modal>
      <div
        className={`fixed inset-0 ${LAYER_CLASS[layer]} flex items-center justify-center bg-black/40 p-4`}
        onClick={onClose}
      >
        <div className={className} onClick={(event) => event.stopPropagation()}>
          {children}
        </div>
      </div>
    </Modal>
  );
}

export function DialogHeader({
  title,
  onClose,
}: {
  title: string;
  onClose: () => void;
}) {
  return (
    <div className="flex items-center justify-between border-b border-line px-3 py-2">
      <h2 className="text-sm font-semibold">{title}</h2>
      <Button variant="quiet" onClick={onClose} aria-label="Close">
        <X size={16} />
      </Button>
    </div>
  );
}
